const routes = [
  {
    path: "/manutencao-motivo-substituicao",
    name: "manutencao-motivo-substituicao",
    meta: {
      allowedPermissions: ["motivo_substituicao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoSubstituicao/ManutencaoMotivoSubstituicaoHome.vue"
      ),
  },
  {
    path: "/manutencao-motivo-substituicao/novo",
    name: "manutencao-motivo-substituicao-novo",
    meta: {
      allowedPermissions: ["motivo_substituicao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoSubstituicao/ManutencaoMotivoSubstituicaoCad.vue"
      ),
  },
  {
    path: "/manutencao-motivo-substituicao/editar/:id",
    name: "manutencao-motivo-substituicao-editar",
    meta: {
      allowedPermissions: ["motivo_substituicao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoSubstituicao/ManutencaoMotivoSubstituicaoEdit.vue"
      ),
  },
];

export default routes;
